<div [class.small]="small()" [rtResizeObserver]="{ initial: false }" class="failed-state-container">
  @let config = emptyStateConfig();
  @if (config) {
    <rt-empty-state
      [icon]="config.icon"
      [title]="config.title"
      [desc]="config.desc"
      variant="small v-centered"
    />
  } @else {
    <rt-empty-state
      class="generic"
      [class.small]="small()"
      [icon]="'chart-bar-broken'"
      [desc]="'tlr.grid_component.failed_state_title' | translate"
      variant="small v-centered"
    >
      @if (allowRefreshing()) {
        <a (click)="refresh.emit()" class="link">{{
          'tlr.grid_component.failed_state_action' | translate
        }}</a>
      }
    </rt-empty-state>
  }
</div>
